"use client";
import { IChildren } from "@/src/app/interface";
import { useProductDetailsContext } from "@/src/provider";
import criteoAd from "@/src/components/LoadAnalysis/analysis/criteo";
import { jointTryOnImg, replaceUrl } from "@/lib/commonService";
import { tryOn } from "@/store";
import { productDetailsStore } from "@/store/pageModules";
import React, { useCallback, useEffect } from "react";
import ColorSelect from "@/src/components/ColorSelect";
import { addProductsSkuClickEvent } from "@/src/models/emailData";
import useBrowserGoodsDetailGA from "@/src/hooks/useBrowserGoodsDetailGA";
interface IProps extends IChildren {}
const ProductDetailsColorSelectClient: React.FC<IProps> = (props) => {
    //商品浏览GA统计
    const [productDetail, activeObj, changeColor] = useProductDetailsContext(
        (state) => [state.productDetail, state.activeObj, state.changeColor],
    );
    const browserGoodsDetailGA = useBrowserGoodsDetailGA();

    const [onChangeSwiperIndex] = productDetailsStore.useProdcutDetailsStore(
        (state) => [state.onChangeSwiperIndex],
    );

    const [changeTryOnPicture] = tryOn.useTryonStore((state) => [
        state.changeTryOnColorPicture,
    ]);
    const changeTryOnImg = useCallback(() => {
        const productImg = jointTryOnImg(
            productDetail.products_id!,
            activeObj.id!,
        );
        changeTryOnPicture(productImg);
    }, [activeObj.id, changeTryOnPicture, productDetail.products_id]);

    useEffect(() => {
        changeTryOnImg();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const colorChange = useCallback(
        async (id: number | string) => {
            changeColor(id);
            changeTryOnImg();
            browserGoodsDetailGA();
            onChangeSwiperIndex(0); // 切换恢复到最初的index

            criteoAd.viewItem(id);

            addProductsSkuClickEvent({
                colorId: id,
                price: activeObj?.onsale?.price,
            });
            replaceUrl("color", `${id}`);
        },
        [
            activeObj?.onsale?.price,
            browserGoodsDetailGA,
            changeColor,
            changeTryOnImg,
            onChangeSwiperIndex,
        ],
    );
    return (
        <ColorSelect
            showSize={React.Children.count(props.children)}
            selected={activeObj.id!}
            onChange={(colorId) => colorChange(colorId)}
        >
            {props.children}
        </ColorSelect>
    );
};

export default ProductDetailsColorSelectClient;
